import { memo, useEffect } from "react";
import { makeStyles } from "tss-react/mui";
import {
  DocumentViewer,
  MiDragAndDropFileUpload,
  MiList,
  MiModalConfirm,
} from "@miplatform/components";
import {
  FILE_MIME_TYPE_EXTENSIONS,
  NOT_APPLICABLE,
} from "@miplatform/constants";
import { mdiTrashCanOutline } from "@mdi/js";
import { DocumentCard } from "@mibuildweb/components";
import { Box } from "@mui/system";
import { useCloseoutDocumentsViewModel } from "./useCloseoutDocumentsViewModel";

export const CloseoutDocuments = memo(
  ({
    isLoading,
    attempt,
    orderTemplate,
    home,
    documents,
    getHome,
    getOrderTemplate,
    getOrder,
  }) => {
    const { theme, classes } = useStyles();
    const {
      loading,
      documentCategory,
      deleteFile,
      isDeleteModalOpen,
      selectedDocument,
      downloadFile,
      printFile,
      getDocumentCategoryOptions,
      uploadFiles,
      setDeleteDocument,
      deleteDocument,
      handleDeleteModalClose,
      handleDocumentSelect,
    } = useCloseoutDocumentsViewModel({
      attempt,
      orderTemplate,
      home,
      getHome,
    });

    useEffect(() => {
      getDocumentCategoryOptions();
      getOrderTemplate(attempt.assignment?.order?.orderTemplateId);
      getOrder(attempt.orderId);
    }, [attempt]);

    return (
      <Box className={classes.root}>
        <MiDragAndDropFileUpload
          showUploadButton
          onChange={uploadFiles}
          disabled={loading || isLoading || !documentCategory}
          validFileTypes={documentCategory?.allowedFileFormats || []}
          acceptableFormatText={`Acceptable formats: ${
            documentCategory?.allowedFileFormats
              ?.map((mimeType) => FILE_MIME_TYPE_EXTENSIONS[mimeType])
              .join(", ") || NOT_APPLICABLE
          }`}
        />

        <MiList
          viewType="card"
          data={documents || []}
          CardComponent={DocumentCard}
          cardProps={{
            onPrint: printFile,
            onDelete: setDeleteDocument,
            onDownload: downloadFile,
            onSelect: handleDocumentSelect,
            selectedDoc: selectedDocument,
          }}
          loading={isLoading || loading}
          hideListPagination
        />
        <MiModalConfirm
          title="Delete Document"
          description={`Are you sure you want to delete document ${
            deleteFile?.metadata_Title || deleteFile?.filename
          }?`}
          titleIcon={{
            path: mdiTrashCanOutline,
            color: theme.palette.error.main,
          }}
          open={isDeleteModalOpen}
          disableClick={loading}
          handlePositive={deleteDocument}
          handleNegative={handleDeleteModalClose}
        />
        <DocumentViewer
          documents={[
            selectedDocument,
            ...documents.filter((d) => d.id !== selectedDocument?.id),
          ]}
          onUnfullscreen={() => handleDocumentSelect(null)}
          fullScreenStatus={selectedDocument}
        />
      </Box>
    );
  }
);

const useStyles = makeStyles()((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2),
  },
}));
